"use client"

import styled from "@emotion/styled"
import ExpertsSwiper from "./ExpertsSwiper"
import HeroContent from "./HeroContent"

const HeroSection = styled.div`
  display: flex;
  position: relative;
  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: calc(100vh - 83px);
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    min-height: calc(100vh - 125px);
  }
`

const HeroImageContainer = styled.div`
  position: relative;
  /* background-image: url("/images/hero-bg-48769a.jpg"); */
  background-size: cover;
  background-position: center;
  width: 350px;
  ${(props) => props.theme.breakpoints.up("xl")} {
    width: 532px;
  }
`

const MainContentWrapper = styled.div`
  margin-right: 224px;
  ${(props) => props.theme.breakpoints.up("xl")} {
    margin-right: 336px;
  }
`

export default function MainContent() {
  return (
    <MainContentWrapper>
      <HeroSection>
        <HeroImageContainer>
          <video
            src="/videos/bgrebuild_video.webm"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
            // poster="/images/hero-bg-48769a.jpg"
          />
        </HeroImageContainer>
        <HeroContent />
      </HeroSection>

      <ExpertsSwiper />
    </MainContentWrapper>
  )
}
